import { motion } from "framer-motion";
import { APP_CATEGORIES } from "../../data/site";

export default function AppCategories() {
  return (
    <section
      id="categories"
      className="py-20 md:py-28 bg-white"
      data-testid="categories-section"
    >
      <div className="container">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-12">
          <div className="lg:col-span-8">
            <p className="text-overline text-electric mb-3">03 — Categories</p>
            <h2 className="font-display text-4xl md:text-5xl font-extrabold text-charcoal text-balance">
              App Marketing for Every Category — Gaming, FinTech, EdTech & More
            </h2>
          </div>
          <p className="lg:col-span-4 text-zinc-600 leading-relaxed">
            We've grown apps across 50+ verticals. Pick your category — we've
            already mapped its acquisition channels, competitor stack, creator
            landscape and full-funnel marketing playbook.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-px bg-zinc-200 border border-zinc-200">
          {APP_CATEGORIES.map((c, idx) => {
            const Icon = c.icon;
            return (
              <motion.div
                key={c.label}
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.3, delay: idx * 0.03 }}
                className="aspect-square bg-white p-5 flex flex-col items-start justify-between hover:bg-charcoal hover:text-white transition-colors group"
                data-testid={`category-${c.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                <Icon
                  className="w-6 h-6 text-electric"
                  strokeWidth={2}
                  aria-hidden
                />
                <div>
                  <div className="font-display text-base md:text-lg font-bold text-charcoal group-hover:text-white">
                    {c.label}
                  </div>
                  <div className="text-[11px] uppercase tracking-widest text-zinc-400 group-hover:text-zinc-400 mt-1">
                    Marketing ready
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
